import "../../style/scss/selectionPanel.scss";
import { DateTime } from "luxon";
import { MdCheckBoxOutlineBlank, MdOutlineCheckBox } from "react-icons/md";

export default function EmploymentSelectionListItem(props) {
  const startDate = props.employment.StartDate
    ? DateTime.fromISO(props.employment.StartDate).toFormat("MM / yyyy")
    : "";
  const endDate = props.employment.EndDate
    ? DateTime.fromISO(props.employment.EndDate).toFormat("MM / yyyy")
    : "Now";

  const onClick = (e) => {
    if (props.onClick) props.onClick(props.employment.ID, e);
    if (props.onChange) props.onChange(props.employment.ID, e);
  };

  const employers = props.employers || [];
  const client = employers.find((e) => e.ID === props.employment.ClientID);
  const intermediary = employers.find((e) => e.ID === props.employment.IntermediaryID);
  const employer = employers.find((e) => e.ID === props.employment.EmployerID);
  const name =
    (client || intermediary || employer)?.Name ||
    (client || intermediary || employer)?.ShortName ||
    "Employer";
  const title = props.employment.Title || props.employment.title || "";
  const dates = startDate ? `${startDate} – ${endDate}` : "";

  return (
    <div
      className={
        "Job selectionPanel checkRow employment-select-item" +
        (props.selected ? " selected" : "")
      }
      id={props.employment.ID}
      onClick={onClick}
      role="checkbox"
      aria-checked={!!props.selected}
    >
      <span className="icon">
        <MdCheckBoxOutlineBlank
          size={22}
          color="#0075FF"
          className={props.selected ? "hidden" : ""}
          aria-hidden
        />
        <MdOutlineCheckBox
          size={22}
          color="#0075FF"
          className={props.selected ? "" : "hidden"}
          aria-hidden
        />
      </span>
      <div className="employment-select-item__body">
        <div className="employment-select-item__row">
          <span className="title">{name}</span>
          {dates ? <span className="rightText">{dates}</span> : null}
        </div>
        {title ? <span className="byline">{title}</span> : null}
      </div>
    </div>
  );
}
